import { forwardRef, useContext } from "react";
import PropTypes from "prop-types";
// form
import { useFormContext, Controller } from "react-hook-form";
// ----------------------------------------------------------------------
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import flags from "react-phone-number-input/flags";
import { FormControl, FormHelperText, TextField } from "@mui/material";
import FormControlContext from "@mui/material/FormControl/FormControlContext";

RHFPhoneField.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
};

export default function RHFPhoneField({ name, helperText, label, sx, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <FormControl
          sx={{
            display: "inline-flex",
            flexDirection: "column",
            position: "relative",
            minWidth: "0",
            padding: "0",
            margin: "0",
            border: "0",
            verticalAlign: "top",
            width: "100%",
          }}
        >
          <FormControlContext.Provider value={{ error }}>
            <PhoneInput
              name={name}
              placeholder="Enter phone number"
              value={field.value}
              onChange={field.onChange}
              inputComponent={PhoneInputRender}
              label={label}
              flags={flags}
            />

            {(Boolean(error) || helperText) && (
              <FormHelperText error={Boolean(error)}>{error ? error?.message : helperText}</FormHelperText>
            )}
          </FormControlContext.Provider>
        </FormControl>
      )}
    />
  );
}

const PhoneInputRender = forwardRef((props, ref) => {
  const { error } = useContext(FormControlContext);
  return (
    <TextField
      {...props}
      InputProps={{
        style: {
          backgroundColor: "#fff",
        },
      }}
      inputRef={ref}
      fullWidth
      label={props.label}
      variant="outlined"
      name={props.name}
      error={Boolean(error)}
    />
  );
});
